<template>
<div>
  <AppHeader title="Daily Items" />
    <div class="container">
    <div class="container left">
      <div class="row" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <ReportsMenu />
          </div>
        </div> -->
        <div class="col-sm-11" style="text-align: center">
          <div class="col-sm-2" style="text-align: right">
            <div style="text-align: right; color: white">
              <label title="Date" style="font-size: 1.5em">Date:</label>
            </div>
          </div>
          <div style="text-align: left">
            <datepicker
              class="col-sm-2"
              v-model="state.date"
              name="selected_date"
              format="yyyy-MM-dd"
              style="width: max-content"
              @selected="parentfunctionSelectedhandler"
              @opened="datepickerOpenedFunction"
              @closed="parentfunctionCloseHandler"
            >
            </datepicker>
          </div>

          <div style="text-align: left">
            <datepicker
              class="col-sm-2"
              v-model="stateTo.dateTo"
              id="select_todate"
              name="selected_date_to"
              format="yyyy-MM-dd"
              style="width: max-content"
              @selected="parentfunctionSelectedhandler"
              @opened="datepickerOpenedFunction"
              @closed="parentfunctionCloseHandler"
            >
            </datepicker>
          </div>
          <div class="col-sm-6" style="text-align: left">
            <div
              class="row"
              style="
                text-align: left;
                display: flex;
                justify-content: space-around;
              "
            >
              <div
                style="
                  display: flex;
                  color: #fff;
                  margin: 0 1rem;
                  justify-content: space-evenly;
                  align-items: center;
                "
                class="col-sm-6"
              >
                <label style="margin: 0">Detailed Report</label>
                <input
                  style="margin: 0"
                  v-model="detailed_report"
                  @change="handleChangeCheck"
                  type="checkbox"
                />
              </div>
              <!-- <input type="text" v-model="itemgroupval" placeholder="Department Name" v-on:keyup.enter="handleFindItemsDaily()" class="form-control" style="font-size:1.5em;width: 50%; height: fit-content"> -->

              <ModelSelect
                placeholder="Select Department Name"
                v-on:keyup.enter="handleFindItemsDaily()"
                :options="departments"
                v-model="itemgroupval"
                style="color: black; width: 60%;border-radius: 5px;"
              />

              <button
                class="btn btn-success"
                style="font-size: 1.5em"
                @click="handleFindItemsDaily()"
              >
                Find
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="toggle">
        <br />
        <div style="background-color: #fff" v-if="showChart">
          <BarChart :chartData="chartData" />
        </div>
        <div
          class="row table-wrap"
          style="color: #fff; padding: 0 0 0 25%"
        ></div>

        <div
          v-if="showChart"
          class="row table-wrap"
          style="color: #fff; "
        >
          <div style="text-align: right ;margin: 5px 0px">
            <button
              class="btn btn-success"
              style="font-size: 1.5em"
              @click="printReportChart('bar-chart')"
            >
              Print
            </button>
          </div>

          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th
                  v-if="detailed_report"
                  style="font-size: 1.5em; text-align: right"
                >
                  Sales Date
                </th>
                <th style="font-size: 1.5em; text-align: right">Item Name</th>
                <th style="font-size: 1.5em; text-align: right">Items Count</th>
                <th style="font-size: 1.5em; text-align: right">Quantity</th>
                <th style="font-size: 1.5em; text-align: right">Return</th>
                <th style="font-size: 1.5em; text-align: right">Price</th>
                <th style="font-size: 1.5em; text-align: right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itemsDaily" :key="item.itemName">
                <td
                  v-if="detailed_report"
                  style="font-size: 1.5em; text-align: right"
                >
                  {{ item.orderDate }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ item.itemName }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ item.count_item }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ parseFloat(item.total_qty).toFixed(3) }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ parseFloat(item.total_qty_return).toFixed(3) }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ formatNumber(item.total_price / item.total_qty) }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ formatNumber(parseFloat(item.total_price).toFixed(2)) }}
                </td>
              </tr>

              <tr>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                    font-weight: bold;
                  "
                >
                  Totals
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  {{ formatNumber(parseFloat(totalCount_).toFixed(0)) }}
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                ></td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                ></td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                ></td>
                <td
                  v-if="detailed_report"
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                ></td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  {{ formatNumber(parseFloat(totalTotal_).toFixed(2)) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
// import ReportsMenu from "@/components/ReportsMenu";
import AppHeader from "@/components/AppHeader";
import BarChart from "@/components/BarChart";
import Datepicker from "vuejs3-datepicker";
import "vue-date-pick/dist/vueDatePick.css";
import "vue-search-select/dist/VueSearchSelect.css";

import { ModelSelect } from "vue-search-select";
export default {
  mixins: [commonServices],
  mounted() {
    //this.$el.querySelector('#paid_by').disabled = true;

    const nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth();
    let day = nowDate.getDate();
    this.state.date = new Date(year + "", month + "", day + "");
    this.stateTo.dateTo = new Date(year + "", month + "", day + "");
    this.orderDate = this.state.date;
    if (localStorage.appId === undefined && localStorage.appId === null) {
      this.$router.push({ name: "login" });
    }
    if (localStorage.reports_ok === "1") {
      this.reports_ok = true;
    }

    this.language = "ar";
    this.handleLanguage();
    this.getLogo();
    this.getDepartments();
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { AppHeader, BarChart, Datepicker, ModelSelect },
  data: function () {
    return {
      state: { date: new Date(2016, 9, 16) },
      stateTo: { dateTo: new Date(2016, 9, 16) },
      chartHeight: 400,
      chartData: { labels: [], datasets: [] },
      reports_ok: false,
      users: [],
      usersJson: {},
      dataItems: [],
      showError: false,
      showChart: false,
      logoImage: "",
      itemsDaily: [],
      itemgroupval: 0,
      mainErrorMsg: "",
      logoUrl: "",
      jsonData: {},
      itemsDailyJson: {},
      language: "en",
      detailed_report: false,
      languageName: "",
      toggle: false,
      orderDate: "",
      departments: [],
      paid_by: 0,
      select_all: false,
      select_todate: false,
      totalCount_: 0,
      totalQuantity_: 0,
      totalReturn_: 0,
      totalPrice_: 0,
      totalTotal_: 0,
      deptWiseReportDate: "",
    };
  },
  methods: {
    calcReportTotals(data) {
      let totalCount = 0;
      let totalQuantity = 0;
      let totalReturn = 0;
      let totalPrice = 0;
      let totalTotal = 0;

      data.forEach(function (item) {
        totalCount =
          totalCount +
          Math.round(parseFloat(item.count_item).toFixed(0) * 100) / 100;
        totalQuantity =
          totalQuantity +
          Math.round(parseFloat(item.total_qty).toFixed(3) * 1000) / 1000;
        totalReturn +=
          Math.round(parseFloat(item.total_qty_return).toFixed(3) * 1000) /
          1000;
        totalPrice +=
          Math.round(
            parseFloat(item.total_price / item.total_qty).toFixed(2) * 100
          ) / 100;
        totalTotal += Math.round(parseFloat(item.total_price) * 100) / 100;
      });
      this.totalCount_ = totalCount;
      this.totalQuantity_ = totalQuantity;
      this.totalReturn_ = totalReturn;
      this.totalPrice_ = totalPrice;
      this.totalTotal_ = totalTotal;
      console.log("this.totalTotal_", this.totalTotal_);
    },

    printReportChart(id) {
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      //let reportFooter = "Printed on: "+year+"-"+month+"-"+day+ " "+time;
      let reportDate = this.dateToYMD(this.state.date);
      let reportDateTo = this.dateToYMD(this.stateTo.dateTo);
      let reportHeader = "";
      if (reportDate == reportDateTo) {
        reportHeader =
          `Department ${this.itemgroupval} Items Report On ` +
          this.dateToYMD(this.state.date);
      } else {
        reportHeader =
          `Department ${this.itemgroupval} Items Report Between ` +
          this.dateToYMD(this.state.date) +
          " AND " +
          this.dateToYMD(this.stateTo.dateTo);
      }
      let deptWiseReportDate = this.state.date;
      let reportData = this.itemsDaily;
      let totalCount = 0;
      let totalQuantity = 0;
      let totalReturn = 0;
      let totalPrice = 0;
      let totalTotal = 0;

      reportData.forEach(function (item) {
        totalCount =
          totalCount +
          Math.round(parseFloat(item.count_item).toFixed(0) * 100) / 100;
        totalQuantity =
          totalQuantity +
          Math.round(parseFloat(item.total_qty).toFixed(3) * 1000) / 1000;
        totalReturn +=
          Math.round(parseFloat(item.total_qty_return).toFixed(3) * 1000) /
          1000;
        totalPrice +=
          Math.round(
            parseFloat(item.total_price / item.total_qty).toFixed(2) * 100
          ) / 100;
        totalTotal += Math.round(parseFloat(item.total_price) * 100) / 100;
      });
      this.printItemsDailyReport(
        reportData,
        reportDateTo,
        reportHeader,
        this.deptWiseReportDate,
        id,
        totalCount,
        totalQuantity,
        totalReturn,
        totalPrice,
        totalTotal
      );
    },
    printItemsDailyReport(
      reportData,
      reportDateTo,
      reportHeader,
      reportDate,
      id,
      totalCount,
      totalQuantity,
      totalReturn,
      totalPrice,
      totalTotal
    ) {
      var canvasEle = document.getElementById(id);
      let self = this;
      let viaInvStr =
        '<div style="width:100%;text-align:center"><table width="100%" align="left" style="margin-right:0px; margin-left:0px">';
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="center" width="100%" style="border-bottom: #000000 0px solid; vertical-align:bottom"><tr><td width="100%" align="center"><img style="width:700px" src="' +
        canvasEle.toDataURL() +
        '" /></td></tr></table>';
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + "<tr><td>";
      //viaInvStr = viaInvStr + '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="left" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportHeader+'</p></b></td><td width="50%" align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td width="50%" align="left"><b><p style="font-size:1.5em">'+reportDate+ '</p></b></td></tr></table>';
      viaInvStr =
        viaInvStr +
        '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="left" style="vertical-align:bottom"><b><p style="font-size:1.5em">' +
        reportHeader +
        '</p></b></td><td width="50%" align="left" ><b><p style="font-size:1.5em"></p></b></td><td width="50%" align="left"><b><p style="font-size:1.5em"></p></b></td></tr></table>';
      viaInvStr = viaInvStr + "</td></tr>";
      //viaInvStr = viaInvStr + '<tr><td>';
      //viaInvStr = viaInvStr + '<table align="left" width="25%"  style="border-bottom: #000000 2px solid;"><tr><td width="50%" align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td width="50%" align="left"><b><p style="font-size:1.5em">'+reportDate+ '</p></b></td></tr></table>';
      //viaInvStr = viaInvStr + '</td></tr>';
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";

      viaInvStr =
        viaInvStr +
        '<table align="center" width="90%" style="border-bottom: #000000 2px solid;"><tr>';
      // if(
      viaInvStr = self.detailed_report
        ? viaInvStr +
          '<td align="left"><b><p style="font-size:1.5em">Sales Date</p></b></td>'
        : viaInvStr;
      viaInvStr =
        viaInvStr +
        '<td align="left"><b><p style="font-size:1.5em">Item Name</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Items Count</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Quantity</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Return</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Price</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Total</p></b></td></tr>';
      //viaInvStr = viaInvStr + '</td></tr>';
      //viaInvStr = viaInvStr + '<tr><td>';
      //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
      reportData.forEach(function (item) {
        viaInvStr = viaInvStr + "<tr>";
        viaInvStr = self.detailed_report
          ? viaInvStr +
            '<td align="left"><p style="font-size:1.5em">' +
            item.orderDate +
            "</p></td>"
          : viaInvStr;
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1.5em">' +
          item.itemName +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          item.count_item +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          parseFloat(item.total_qty).toFixed(3) +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          parseFloat(item.total_qty_return).toFixed(3) +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(item.total_price / item.total_qty) +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(item.total_price) +
          "</p></td></tr>";
        //viaInvStr = viaInvStr + '</td></tr>';
        //viaInvStr = viaInvStr + '<tr><td>';
      });
      viaInvStr =
        viaInvStr +
        '<tr style="border-top: #000000 2px solid; vertical-align:bottom">';

      viaInvStr =
        viaInvStr +
        '<td align="left" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">Totals</p></td>';
      viaInvStr = self.detailed_report
        ? viaInvStr +
          '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em"></p></td>'
        : viaInvStr;
      viaInvStr =
        viaInvStr +
        '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(totalCount).toFixed(0)) +
        "</p></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em"></p></td>';

      viaInvStr =
        viaInvStr +
        '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em"></p></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em"></p></td>';

      //viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalQuantity).toFixed(3))+'</p></td>';
      //viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalReturn).toFixed(3))+'</p></td>';
      //viaInvStr = viaInvStr + '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">'+this.formatNumber(parseFloat(totalPrice).toFixed(2))+'</p></td>';

      viaInvStr =
        viaInvStr +
        '<td align="right" style="border-top: #000000 2px solid; vertical-align:bottom"><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(totalTotal).toFixed(2)) +
        "</p></td></tr>";
      viaInvStr = viaInvStr + "</table>";
      viaInvStr = viaInvStr + "</td></tr>";

      viaInvStr = viaInvStr + "</table></div>";
      this.sharedPrintElemmRep(viaInvStr);
    },

    parentfunctionSelectedhandler() {
      console.log("state.date", this.state.date);
    },
    datepickerOpenedFunction() {
      console.log("state.date", this.state.date);
    },
    parentfunctionCloseHandler() {
      console.log("state.date", this.state.date);
    },

    addOption(selectbox, value, text) {
      var optn = document.createElement("OPTION");
      optn.text = text;
      optn.value = value;
      selectbox.options.add(optn);
    },
    handleChangeCheck(e) {
      this.toggle = false;
      if (this.itemgroupval != "" && this.stateTo && this.state) {
        this.findItemsDaily();
      }
    },
    handleFindItemsDaily() {
      this.findItemsDaily();
    },
    findItemsDaily: async function () {
      if (this.itemgroupval == "") {
        this.showAlert("Please Enter Department Name");
        return;
      }
      this.itemsDailyJson.appId = localStorage.appId;
      this.itemsDailyJson.detailedReport = this.detailed_report ? 1 : 0;

      this.itemsDailyJson.itemGroup = this.itemgroupval;
      this.itemsDailyJson.orderDate = this.dateToYMD(this.state.date);
      this.itemsDailyJson.orderDateTo = this.dateToYMD(this.stateTo.dateTo);
      this.deptWiseReportDate = this.dateToYMD(this.state.date);
      this.itemsDailyJson.paid_by = this.paid_by;
      console.log("this.select_all", this.select_all);
      try {
        let dataURL = this.apiURL + "GiftCard/findItemsByDepDailyAll";

        let response = await axios.post(dataURL, this.itemsDailyJson);
        if (response.data.status === "success") {
          this.itemsDaily = response.data.results.itemsDaily;
          this.calcReportTotals(response.data.results.itemsDaily);

          //this.calcReportTotals();
          this.showChart = true;
          let data_ = [];
          let labels_ = [];
          if (response.data.results.itemsDaily.length > 0) {
            let self = this;
            response.data.results.itemsDaily.forEach(function (item) {
              let arr = [];
              if (self.detailed_report) {
                arr.push(item.orderDate);
              }
              arr.push(item.itemName);
              labels_.push(arr);

              data_.push(item.total_price);
            });
            this.chartData.labels = labels_;
            this.chartData.datasets = [];
            this.chartData.datasets.push({
              data: data_,
              backgroundColor: [
                "yello",
                "green",
                "blue",
                "red",
                "cyan",
                "navy",
                "#524178",
                "#aa3344",
              ],
              label: `Sales Amount For ${this.itemgroupval}`,
              fill: false,
              borderColor: "rgb(43, 76, 153)",
              tension: 0.1,
              pointRadius: 0.1,
              borderWidth: 2,
            });
          }
          //console.log("this.dataItems", this.dataItems)
          this.toggle = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getDepartments: async function () {
      try {
        let dataURL = this.apiURL + "Products/getDepartments";
        let logoJson = { appId: localStorage.appId };
        let response = await axios.post(dataURL, logoJson);
        if (response.data.status === "success") {
          this.departments = response.data.results.map((el) => {
            return { value: el, text: el };
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLogo: async function () {
      try {
        let dataURL = this.apiURL + "Orders/getInvoiceLogo";
        let logoJson = { appId: localStorage.appId };
        let response = await axios.post(dataURL, logoJson);
        if (response.data.status === "success") {
          this.logoUrl = response.data.results.logourl;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
  /*overflow-y: hidden;*/
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}
.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}
.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}
.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}
</style>
